import {SistemaRol} from './sistemaRol';
import { Usuario } from './usuario';

export class UsuarioNuevo {

  usuario: Usuario;
  sistemasRoles: Array<SistemaRol>;

}